import { IShareLinkInfo } from "@/types/summary";
import RefreshIcon from "@/assets/common/ic_refresh.svg?react";
import { LinkValidPeriodType, LinkValidTextMap } from "@/constants/share";
import dayjs from "dayjs";
import { IPartialShareSettingAttr } from "@/types/share";

interface LinkValidityRefreshBtnProps {
  shareInfo?: IShareLinkInfo | null;
  disabled: boolean;
  onShareSettingChange: (newParams: IPartialShareSettingAttr) => void;
}

const LinkValidityRefreshBtn = ({
  shareInfo,
  disabled,
  onShareSettingChange,
}: LinkValidityRefreshBtnProps) => {
  const handleRefresh = (e: React.MouseEvent<SVGSVGElement>) => {
    e.stopPropagation();
    onShareSettingChange({
      linkValidity: shareInfo?.linkValidity,
    });
  };
  const showRefreshIcon =
    shareInfo?.linkValidity !== LinkValidPeriodType.Permanent;
  return (
    shareInfo && (
      <div className="mt-1 text-mx-secondary op-50 text-3 h-4.25 lh-4.25 flex items-center">
        {`${LinkValidTextMap[shareInfo?.linkValidity]}有效${
          showRefreshIcon
            ? `（${dayjs(shareInfo.expiredTime).format("MM-DD HH:mm")}前）`
            : ""
        }`}
        {!disabled && showRefreshIcon && (
          <RefreshIcon className="ml-2" onClick={handleRefresh} />
        )}
      </div>
    )
  );
};

export default LinkValidityRefreshBtn;
